<template>
	<div class="heading-title-wrapper">
		<div class="review-title" :style="{'--font-size': fontSize }" >
			<hr class="border">
			{{ headline }}
			<hr class="border">
		</div>
		<div class="review-ratings-wrapper">
			<div class="rating">
				<div class="reviewer-name">{{ name }}</div>
				<StarRating :stars="grades.length" :fill-count="fillCount" />
			</div>
			<div class="review">{{ reviewText }}</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import StarRating from "@/components/base/StarRating";

export default {
	name: 'ReviewHeading',
	components: {
		StarRating,
	},
	data() {
		return {
			activeSlot: null,
		};
	},
	computed: {
		...mapState({
			grades: (state) => state.global.api.data.config.performance_grades,
		}),
		...mapGetters({
			rating: "game/performance/rating",
			headline: "game/reviews/randomHeadline",
			name: "game/reviews/randomReviewer",
			reviewText: "game/reviews/randomReviewText",
		}),
		fillCount() {
			return this.grades.findIndex((grade) => grade.id === this.rating) + 1;
		},
		fontSize() {
			const size = 1400 / this.headline.length;
			return `${size}px`;
		},
	},
};
</script>

<style lang="scss" scoped>
	.heading-title-wrapper {
		position: relative;
		margin: 5% auto 0;
		width: 80vw;
		height: 225px;
		background-image: url('/static/newspaper-rip.svg');
		background-repeat: no-repeat;
		background-position: center;
		background-size: contain;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		@include tablet { width: 80vw; }

		@include desktop {
			width: 1000px;
			height: 275px;
		}
	}

	.review-title {
		position: relative;
		text-transform: uppercase;
		text-align: center;
		font-size: calc(var(--font-size) * 0.5);
		line-height: 1.1;

		@include tablet { font-size: calc(var(--font-size) * 0.65); }
		@include desktop { font-size: var(--font-size); }
		@include desktop-sm { font-size: calc(var(--font-size) * 0.9); }
	}

	.border {
		width: 100%;
		height: 3px;
		margin: 0;
		border-left: none;
		border-right: none;
		border-top: 1px solid $background-color-dark;
		border-bottom: 1px solid $primary-color-dark;
		background: none;

		@include tablet { border-width: 2px; }
	}

	.review-ratings-wrapper {
		display: flex;
		width: 90%;
		margin-top: 2%;
		flex-direction: row;
		justify-content: center;
		align-items: flex-start;
		font-family: $body-font-alt;
		font-size: $font-size-x-sm;
		color: $primary-color-dark;

		@include tablet {
			width: 80%;
			font-size: $font-size-sm;
		}

		@include desktop {
			width: 60%;
			font-size: $font-size-sm;
		}

		&:before,
		&:after {
			content: '';
			background-image: url('~@/assets/images/quotation-mark.svg');
			background-repeat: no-repeat;
			background-position: center;
			background-size: contain;
			margin: 0 2%;
			height: 25px;
			width: 25px;
			overflow: visible;

			@include tablet {
				height: 25px;
				width: 25px;
			}

			@include desktop {
				height: 50px;
				width: 50px;
			}
		}

		&:after {
			transform: rotate(180deg);
		}
	}

	.rating {
		text-transform: uppercase;
		width: 40%;
		padding-left: 3%;
	}

	.review {
		width: 40%;
	}
</style>



// WEBPACK FOOTER //
// src/components/game/review/ReviewHeading.vue